import { createEvent, createStore } from 'effector'

export const actions = {
  setControles: createEvent<ControleQualiteResponse[]>('setControles'),
  addControle: createEvent<ControleQualiteResponse>('addControle'),
  deleteControle: createEvent<string>('deleteControle'),
  resetControles: createEvent('resetControles'),
  setForm: createEvent<Partial<ControleForm>>('setControleForm'),
  resetForm: createEvent('resetControleForm'),
  addForm: createEvent<ControleForm>('addControleForm'),
  setForms: createEvent<ControleForm[]>('setControleForms'),
  removeForm: createEvent<string>('removeControleForm'),
  resetForms: createEvent('resetControleForm'),
  reset: createEvent('reset'),
}

const initialState: ControleState = {
  controles: [],
  form: {
    reponses: [],
    localisationIds: [],
  } as unknown as ControleForm,
  forms: [],
}

export const store = createStore<ControleState>(initialState, { name: 'controle' })
  .on(actions.setControles, (s, controles) => ({ ...s, controles }))
  .on(actions.addControle, (s, controle) => ({ ...s, controles: [...s.controles, controle] }))
  .on(actions.deleteControle, (s, controleId) => ({ ...s, controles: s.controles.filter((c) => c.id !== controleId) }))
  .on(actions.resetControles, (s) => ({ ...s, controles: initialState.controles }))
  .on(actions.setForm, (s, part) => ({ ...s, form: { ...s.form, ...part } }))
  .on(actions.resetForm, (s) => ({ ...s, form: initialState.form }))
  .on(actions.addForm, (s, form) => ({ ...s, forms: [...s.forms, form] }))
  .on(actions.setForms, (s, forms) => ({ ...s, forms }))
  .on(actions.removeForm, (s, id) => ({ ...s, forms: s.forms.filter((f) => f.id !== id) }))
  .on(actions.resetForms, (s) => ({ ...s, forms: initialState.forms }))
  .reset(actions.reset)
